import CalculatorCarousel from './CalculatorCarousel';
import CalculatorSideBlock from './CalculatorSideBlock';
import DashboardHomeSkeleton from './DashboardHomeSkeleton';
import DocumentListSkeleton from './DocumentListSkeleton';
import GuideSkeleton from './GuideSekeleton';
import MyProfileSkeleton from './MyProfileSkeleton';
import ServiceDetailsSkeleton from './ServiceDetailsSkeleton';

export {
  GuideSkeleton,
  ServiceDetailsSkeleton,
  DocumentListSkeleton,
  MyProfileSkeleton,
  DashboardHomeSkeleton,
  CalculatorSideBlock,
  CalculatorCarousel,
};
